var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepper"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step.id,staticClass:"step",class:{
      'step--active': step.active,
      'step--completed': _vm.checkIfCompleted(index)
    }},[_c('div',{staticClass:"step__label"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(step.label))]),_c('div',{staticClass:"step__line"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }